<template>
  <div>
    <!-- width="40%" -->
    <el-dialog
      :visible.sync="studyVisible"
      width="600px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :show-close="false"
    >
      <div slot="title" class="el-dialog-title">
        签到

        <div class="title_close" @click="studyVisible = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="signf">
        <div class="sign">
          <!-- <div class="header-title">
          <div>每日签到</div>
        </div> -->

          <div style="width: 100%; padding: 0px 15px 0px 15px">
            <div class="signcard-header">
              <div>
                <!-- <div>已连续签到</div>
          <div style="font-size: 20px; color: #ff4e00">{{ signdata.days }}</div>
          <div>天</div> -->
              </div>
              <!-- <div class="signdatemonth">
              <div class="signdatemonth-padding">
                <div @click="pickPre(currentYear, currentMonth)">上一月</div>
                <div
                  style="
                    font-size: 16px;
                    text-algin: center;
                    width: 100%;
                    padding-bottom: 10px;
                  "
                >
                  {{ currentYear }}年{{ currentMonth }}月
                </div>
                <div @click="pickNext(currentYear, currentMonth)">下一月</div>
              </div>
            </div> -->
              <div class="signcard-section">
                <div class="signcard-title">
                  <div>日</div>
                  <div>一</div>
                  <div>二</div>
                  <div>三</div>
                  <div>四</div>
                  <div>五</div>
                  <div>六</div>
                </div>
              </div>

              <div class="signcard-footer">
                <div class="signcard-list">
                  <div
                    v-for="day in days"
                    :key="day.item"
                    style="position: relative"
                  >
                    <!-- 这里是已签到的 -->
                    <div
                      class="signagree added"
                      v-if="
                        day.isSign && day.day.getMonth() + 1 === currentMonth
                      "
                    >
                      <div
                        style="
                          color: #d1d1d1;
                          position: relative;
                          z-index: 2;
                          position: relative;
                        "
                        :style="{
                          color:
                            day.day.getDate() < new Date().getDate()
                              ? '#fff'
                              : '#fff',
                        }"
                      >
                        <span> {{ day.day.getDate() }}</span>
                      </div>
                    </div>
                    <!-- 这里是未签到的 -->
                    <div
                      class="signagree"
                      v-if="
                        !day.isSign && day.day.getMonth() + 1 === currentMonth
                      "
                      :class="
                        day.day.getDate() < new Date().getDate() ? 'wqd' : ''
                      "
                    >
                      <!-- <div
                      v-if="day.day.getDate() == 1"
                      style="
                        color: white;
                        padding: 2px 4px;
                        position: absolute;
                        top: -1px;
                        left: -1px;
                        font-size: 10px;
                        background-color: #367e77;
                        border-radius: 8px 0 8px 0;
                      "
                    >
                      {{ currentMonth }} 月
                    </div> -->
                      <div
                        style="position: relative"
                        :style="{
                          color:
                            day.day.getDate() < new Date().getDate()
                              ? '#999'
                              : '#606266',
                        }"
                      >
                        <span> {{ day.day.getDate() }}</span>

                        <!-- <div
                        class="nowDay"
                        v-if="day.day.getDate() == new Date().getDate()"
                      ></div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="datestatus == 0"
            class="card-buttonfrom animated rotateIn"
            @click="Sign"
          >
            <div>马上签到</div>
          </div>
          <div
            v-else-if="datestatus == 1"
            class="card-buttonfromgrey animated swing"
          >
            <div>已签到</div>
          </div>
          <!-- <div
          v-else-if="datestatus == 2"
          class="card-buttonfromgrey animated swing"
        >
          <div>签到成功</div>
        </div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userApi from "../../../api/user.js";
export default {
  name: "BtnDetail",
  props: ["researchOptionsId", "customerInfoDTO"],
  data() {
    return {
      signdata: "",
      currentDay: "", // 当前天
      currentMonth: "", // 当前月
      currentYear: "",
      currentWeek: 1, // 一号所在的星期
      days: [], // 当月所有天数
      arrDate: [1], // 当月签到日期
      num: 0,
      datestatus: 0,

      studyVisible: false,
      arr: [],
      nowdate: new Date(), //指定当前显示的月份。如果 value 未指定，则显示当月
    };
  },
  created() {
    this.initData();
  },

  methods: {
    // 返回 类似 2020-01-01 格式的字符串
    formatDate(year, month, day) {
      month < 10 && (month = "0" + month);
      day < 10 && (day = "0" + day);
      const data = year + "-" + month + "-" + day;
      return data;
    },
    initData(cur) {
      let date;
      if (cur) {
        // 切换日期
        date = new Date(cur);
      } else {
        var now = new Date();
        var d = new Date(
          this.formatDate(now.getFullYear(), now.getMonth() + 1, 1)
        );
        date = new Date(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
      }

      this.currentDay = date.getDate(); // 今日日期 几号
      this.currentYear = date.getFullYear(); // 当前年份
      this.currentMonth = date.getMonth() + 1; // 当前月份
      this.currentWeek = date.getDay(); // 0,1...6 星期
      const str = this.formatDate(
        this.currentYear,
        this.currentMonth,
        this.currentDay
      ); // 2020-01-01
      this.days.length = 0; // 初始化日期
      for (var i = this.currentWeek; i > 0; i--) {
        const d = new Date(str);
        d.setDate(d.getDate() - i);
        var dayobject = {};
        dayobject.day = d;
        dayobject.isSign = false;
        this.days.push(dayobject);
      }
      this.num = 0;
      for (var j = 0; j <= 36 - this.currentWeek; j++) {
        const d = new Date(str);
        d.setDate(d.getDate() + j);
        const dddd = d.getDate();
        if (dddd === 1) {
          this.num++;
        }
        if (this.num === 2) {
          return;
        }
        var dayobject = { day: d, isSign: this.isVerDate(dddd) };
        this.days.push(dayobject);
      }
    },

    // // 判断日期是否有签到
    isVerDate(v) {
      // console.log(v,'判断是否有签到')
      return this.arrDate.includes(v);
    },

    Sign() {
      this.$loading.show();
      let params = {
        postTime: this.formatDateTime2(new Date()),
        channel: "pc",
      };
      userApi.setCheak(params).then((res) => {
        if (res.code == 200) {
          this.datestatus = 1;
          this.$message.success("签到成功");
          this.getSingRecord(this.currentYear, this.currentMonth);
          this.$emit("getMouse");
        } else {
          console.log(res);
          this.$message.error(res.msg, "error");
        }
        this.$loading.hide();
      });
    },

    getSingRecord(year, month) {
      this.$loading.show();
      this.days.forEach((val) => {
        val.isSign = false;
      });
      let params = {
        beginDate: `${this.formatDateTime(this.days[0].day)} 00:00:00`,
        endDate: `${this.formatDateTime(
          this.days[this.days.length - 1].day
        )} 23:59:59`,
        channel: "pc",
      };

      userApi.getCheck(params).then((res) => {
        let arr = res.data;
        let ary = [];
        arr.forEach((el) => {
          ary.push(el.createDate.substring(0, 10));
        });

        this.days.forEach((val) => {
          for (let i = 0; i < ary.length; i++) {
            if (ary[i] == this.formatDateTime(new Date())) {
              this.datestatus = 1;
            }
            if (this.formatDateTime(val.day) == ary[i]) {
              val.isSign = true;
            }
          }
        });
        this.$loading.hide();
      });
    },

    formatDateTime2(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      return `${year}-${this.pad(month)}-${this.pad(day)} ${this.pad(
        hour
      )}:${this.pad(minute)}:${this.pad(second)}`;
    },
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      return `${year}-${this.pad(month)}-${this.pad(day)}`;
      // return `${year}-${pad(month)}-${pad(day)} ${pad(hour)}:${pad(minute)}:${pad(second)}`;
    },

    pad(num) {
      return num.toString().padStart(2, "0");
    },

    subCalen(e) {},
    ishow() {
      this.studyVisible = true;
      this.getSingRecord(this.currentYear, this.currentMonth);
    },
  },
};
</script>

<style lang="less" scoped>
.wqd {
  background-color: #fafafa !important;
  border: 1px dashed #ccc !important;
  border-radius: 8px !important;
}
.index {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  overflow-y: scroll;
  background: #f6f6f6;
}
.flex {
  display: flex;
}
.flex_s {
  display: flex;
  justify-content: space-between;
}
.flex_e {
  display: flex;
  justify-content: space-evenly;
}
.shade {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  align-items: center;
  flex-wrap: wrap;
  z-index: 2;
  padding-top: 60px;
}
.shadearray > div {
  width: 100%;
  display: flex;
  justify-content: center;
}
body {
  background-color: rgb(245, 245, 245);
}

.signf {
  background: white;
  padding: 12px 4px;
}
.sign {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 600px;
  @media screen and (max-width: 1023px) {
    width: 100%;
  }
}

.header-title {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
}
.header-title {
  width: 100%;
  height: 67px;
  color: #333;
  font-size: 17px;
  img {
    position: absolute;
    left: 20px;
    bottom: 2px;
  }
}

.header-array {
  width: 100%;
  margin-top: 33px;
  margin-bottom: 17px;
  height: 88px;
  padding: 0px 54px 0px 54px;
}

.header-array > :first-child {
  height: 88px;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.header-card {
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 18px;
}
.header-card > div:nth-child(1) {
  margin-right: 5px;
}
.header-card > div:nth-child(3) {
  margin-left: 5px;
}

.header-text {
  width: 100%;
  line-height: 28px;
  color: white;
  text-align: center;
  font-size: 13px;
}
.header-cardicon {
  position: relative;
  div {
    margin: 0px 2px 0px 2px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  display: flex;
  justify-content: center;
  align-items: center;

  .header-num {
    position: absolute;
    font-size: 40px;
    color: #ff8400;
  }
}
.signcard-header {
  width: 100%;

  background-color: white;
  border-radius: 10px;
  padding-top: 5px;
  padding-bottom: 20px;
  overflow: hidden;

  letter-spacing: 1px;
}
.signcard-header > div:first-child {
  padding-left: 20px;
  font-size: 12px;
  display: flex;
  justify-content: start;
  align-items: center;
  color: rgb(139, 139, 139);
}
.signdatemonth {
  width: 100%;
}
.signdatemonth-padding {
  padding: 5px 20px 5px 20px;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  align-items: center;
}
.signcard-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
}
.signcard-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  @media screen and (max-width: 1023px) {
    padding-left: 0;
    padding-right: 0;
  }

  font-size: 18px;
}
.signcard-title > div {
  color: #9c9c9c;
  width: 14.2%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  text-align: center;
}
.signcard-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.signcard-list {
  width: 100%;
  display: flex;
  justify-content: start;
  padding-left: 20px;
  padding-right: 20px;
  @media screen and (max-width: 1023px) {
    padding-left: 0;
    padding-right: 0;
  }

  font-size: 18px;
  flex-wrap: wrap;
}
.signcard-list > div {
  min-width: 38px;
  width: 14.2%;
  height: 60px;
  margin-top: 13.5px;
  margin-bottom: 13.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  @media screen and (max-width: 1023px) {
    margin-top: 8px;
    margin-bottom: 8px;
    // display: inline-block !important;
    // padding-bottom: 14%;
    height: 40px;

   
  }
}
.signagree {
  width: 70%;
  height: 110%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  position: relative;

  @media screen and (max-width: 1023px) {
    padding-left: 0;
     height: 100%
    // padding-bottom: ;
  }

  .bgcri {
    position: absolute;
    // background: rgba(0, 0, 0, 0);
    background: #008077;
    height: 40px;
    width: 40px;
    // border: 3px solid #008077;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
}
.signcard-list > div > img {
  z-index: 1;
}
.signdate {
  width: 100%;
  display: flex;
  justify-content: center;
}
.signsolid {
  width: 100%;
  height: 2px;
  background-color: #efefef;

  z-index: 0;
  position: absolute;
  top: 13px;
}

.card-buttonfrom {
  cursor: pointer;
  margin-top: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 80px 15px 80px;


  color: white;
  border-radius: 50px;
  font-size: 18px;
  background: linear-gradient(rgb(0, 128, 119), rgb(0, 128, 100));
  
    @media screen and (max-width: 1023px) {
    padding: 10px 60px 10px 60px;
     font-size: 14px;
  }
}
.card-buttonfromgrey {
  margin-top: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #b5b5b5;
  padding: 15px 80px 15px 80px;
  color: white;
  border-radius: 50px;
  font-size: 18px;
  letter-spacing: 2px;
}

/deep/ .el-button-group {
  display: none; //隐藏默认样式
}
.dialog-title {
  text-align: left;
  font-size: 30px;
  color: #000;
  border-bottom: 4px solid #e5e5e5;
  width: calc(100% + 40px);
  margin-left: -20px;
  padding-bottom: 20px;
  padding-left: 60px;
  position: relative;

  span {
  }

  &::before {
    display: block;
    content: "";
    width: 65px;
    height: 4px;
    background-color: var(--ThemeColor);
    position: absolute;
    bottom: -4px;
    left: 60px;
  }
}

.dialog-form {
  padding: 0 60px;
  text-align: left;

  .get-verify {
    width: 100%;
    background-color: #3c4250;
    color: var(--textWhite);
  }

  .dilog-select {
    width: 100%;
  }

  .dialog-btns {
    text-align: center;

    .cancel,
    .confirm {
      font-size: 16px;
    }

    .confirm {
      color: var(--textWhite);
      background-color: var(--ThemeColor);
    }
  }
}
/deep/.el-dialog {
  border-radius: 30px;
  overflow: hidden;
  padding-top: 0;
  background: rgba(0, 0, 0, 0);
}
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog__heade {
  padding: 30px 4px;
}
/deep/.el-dialog__body {
  padding: 0;
}
.el-dialog-title {
  margin: 0;
  padding: 0;
  height: 60px;
  line-height: 60px;
  font-size: 30px;
  color: white;
  background: #008077;
  position: relative;

  @media screen and (max-width: 1023px) {
    height: 40px;
    line-height: 40px;
    font-size: 20px;
  }

  .title_close {
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.added {
  background-color: #008077;
  // border: 1px dashed #ccc;
  border-radius: 8px;

  //  background-color: #fafafa;
  // border: 1px dashed #ccc;
  // border-radius: 8px;
}
.nowDay {
  left: 50%;
  transform: translateX(-50%);
  background-color: #008077;
  position: absolute;
  bottom: -5px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/views/user/components/calendar.vue